module.exports = __webpack_public_path__ + "static/media/0024_FE_LES_ENSEIGNES_LES_FROMAGES_SCRABBLE.ab529bef.webp";